export function isInViewport(element) {
    const rect = element.getBoundingClientRect();

    return rect.top - 200 < 0 && rect.bottom - 200 > 0;
}
